// GENERATED by scripts/generate-route-paths.mjs — do not edit by hand.
// Source: the `path="…"` routes in web/src/App.tsx (redirects and catch-alls left out).
// Regenerate with `npm run route-paths:generate`; tests/web/breadcrumb-helpers.test.ts fails when stale.

export const PAGE_ROUTE_PATTERNS: readonly string[] = [
  "/",
  "/aca-quote/:kind/:id",
  "/accept-invite",
  "/admin/ambassador-fees",
  "/admin/at-risk-calibration",
  "/admin/automations",
  "/admin/automations/:id",
  "/admin/automations/:id/edit",
  "/admin/automations/new",
  "/admin/booking-routing",
  "/admin/commission-reconciliation",
  "/admin/commission-splits",
  "/admin/commissions",
  "/admin/commissions/:id",
  "/admin/commissions/john-hancock",
  "/admin/commissions/pay-runs",
  "/admin/commissions/payroll",
  "/admin/commissions/payroll/:payDate",
  "/admin/commissions/payroll/:payDate/:company",
  "/admin/commissions/statements/:statementId",
  "/admin/commissions/unpaid",
  "/admin/communication-templates",
  "/admin/company-compliance",
  "/admin/compliance/:company",
  "/admin/compliance/instances",
  "/admin/compliance/loan-files/:loanId",
  "/admin/compliance/rules",
  "/admin/dashboards-targets",
  "/admin/data-imports/financial",
  "/admin/database-health",
  "/admin/email-health",
  "/admin/exam-packs",
  "/admin/financial/deposits",
  "/admin/financial/fee-review",
  "/admin/financial/firm-dashboard",
  "/admin/firm-profiles",
  "/admin/fit-cleanup",
  "/admin/insurance-reconciliation",
  "/admin/integrations",
  "/admin/integrations/ad-audiences",
  "/admin/integrations/bookings",
  "/admin/integrations/gusto",
  "/admin/integrations/ivans",
  "/admin/integrations/microsoft-graph",
  "/admin/integrations/quickbooks",
  "/admin/legal-holds",
  "/admin/money/klink-invoices",
  "/admin/money/klinkloans-report",
  "/admin/pipeline-boards",
  "/admin/plaid-live-test",
  "/admin/settings",
  "/admin/shared-mailboxes",
  "/admin/sharepoint-migrate",
  "/admin/staging-outbox",
  "/admin/stew-feedback",
  "/admin/team",
  "/admin/team-compensation",
  "/admin/team/:userId/comp-plan",
  "/admin/view-defaults",
  "/admin/watchlist-rules",
  "/admin/workload-planner",
  "/advisors/:userId/schedule",
  "/all-pages",
  "/appointments",
  "/automations",
  "/automations/on-my-clients",
  "/availability",
  "/book",
  "/book/i/:token",
  "/book/manage/:token",
  "/book/with/:slug",
  "/calendar",
  "/call-recordings/upload",
  "/checkin/:token",
  "/checklists",
  "/checklists/:id",
  "/cleanup",
  "/cleanup/help",
  "/communications",
  "/company-coverage",
  "/company-coverage/:id",
  "/company-coverage/:id/edit",
  "/company-coverage/check",
  "/company-coverage/import",
  "/company-coverage/import/:importId",
  "/company-coverage/life",
  "/company-coverage/missing",
  "/company-coverage/missing/:reviewId",
  "/company-coverage/new",
  "/company-coverage/reviews/:reviewId",
  "/connect/bank/return",
  "/contacts",
  "/contacts/:id",
  "/contacts/:id/snapshot",
  "/dashboard",
  "/dashboard/:company",
  "/dashboard/briefing",
  "/dashboard/cockpit",
  "/dashboard/donna",
  "/dashboard/insurance",
  "/data-needed",
  "/data-needed/team",
  "/desk",
  "/digest/:token",
  "/employers",
  "/employers/:id",
  "/employers/:id/group-plans/:planId",
  "/employers/:id/group-plans/:planId/bring-in",
  "/esign",
  "/esign/:envelopeId",
  "/esign/industry-documents",
  "/esign/industry-documents/:company",
  "/esign/learned",
  "/esign/learned/:company",
  "/esign/settings",
  "/esign/templates",
  "/esign/templates/:company",
  "/f/:publicSlug",
  "/f/r/:rtoken",
  "/f/t/:token",
  "/financial/billing",
  "/forgot-password",
  "/forms",
  "/forms/:slug",
  "/forms/:slug/submissions",
  "/forms/submissions/:id",
  "/help",
  "/households",
  "/households/:id",
  "/households/:id/companies/:slug",
  "/households/:id/requote-worksheet",
  "/households/:id/snapshot",
  "/insurance/carrier-activity",
  "/insurance/ivans-review",
  "/intake/r/:token",
  "/introduce/:token",
  "/license-lookup",
  "/marketing/approvals",
  "/marketing/calendar",
  "/marketing/campaigns",
  "/marketing/campaigns/:id",
  "/marketing/content",
  "/marketing/email-clients",
  "/marketing/events",
  "/marketing/events/:id",
  "/marketing/goals/:id",
  "/marketing/goals/new",
  "/marketing/inbox",
  "/marketing/leaderboard",
  "/marketing/levels",
  "/marketing/levels/:company/:family",
  "/marketing/mail",
  "/marketing/opportunities",
  "/marketing/pieces/:id",
  "/marketing/playbooks",
  "/marketing/playbooks/:company/:family",
  "/marketing/plays",
  "/marketing/plays/:id",
  "/marketing/posts",
  "/marketing/referral-network",
  "/marketing/referrals",
  "/marketing/results",
  "/marketing/reviews",
  "/marketing/series/:id",
  "/marketing/settings",
  "/marketing/settings/:section",
  "/marketing/studio/founder",
  "/marketing/studio/share",
  "/marketing/today",
  "/medicare-quote/:kind/:id",
  "/mortgage/call-report",
  "/mortgage/client-sign-in",
  "/mortgage/closed-loan-report",
  "/mortgage/compliance",
  "/mortgage/loan-files/:fileId",
  "/mortgage/loan-log",
  "/mortgage/watch",
  "/my-commissions",
  "/my-comp-plan",
  "/my-comp-plan/statements/:statementId",
  "/my-day",
  "/my-mortgage-compliance",
  "/notifications",
  "/ongoing-care",
  "/ongoing-care/:id",
  "/ongoing-care/:id/edit",
  "/ongoing-care/month/:ym",
  "/ongoing-care/new",
  "/ongoing-care/plans",
  "/ongoing-care/plans/:defId",
  "/ongoing-care/plans/new",
  "/opportunities",
  "/opportunities/:id",
  "/opportunities/aging",
  "/opportunities/board",
  "/opportunities/forecast",
  "/planning/book-of-business",
  "/planning/deposits",
  "/pm-fund",
  "/pm-guidelines",
  "/pm-underwriting/:subjectType/:subjectId",
  "/preferences/:token",
  "/processing",
  "/processing/:id",
  "/processing/board",
  "/pulse",
  "/q/:token",
  "/referrals",
  "/reports",
  "/request/:token",
  "/requests/:id",
  "/reset-password",
  "/retention-schedule",
  "/review/:token",
  "/saved-email/:activityId",
  "/saved-views/:slug",
  "/security",
  "/service-records",
  "/service-records/:id",
  "/services-check",
  "/settings",
  "/sign-in",
  "/sign/:token",
  "/sign/complete",
  "/structured-notes",
  "/system-jobs",
  "/tasks",
  "/transactions/:id",
  "/trends",
  "/trusts/:id",
  "/upcoming-communications",
  "/upload/:token",
  "/vendors",
  "/vendors/:id",
  "/watchlist",
];
